/**
 * Datos publicados del predio. Todo lo que aparece en la ficha y en el mapa
 * sale de aquí para que no existan dos versiones de un mismo dato.
 */

export const SITE = {
  name: "Torre El Boquerón",
  place: "El Boquerón, Santa Tecla · La Libertad",
  longitude: -89.2822644,
  latitude: 13.7305268,
} as const;

export const TOWER_HEIGHT_METERS = 42;

/** Altitud del predio según el Copernicus DEM en la coordenada compartida. */
export const SITE_ELEVATION_APPROX = 1760;

export const LEASE_YEARS = 5;

const WHATSAPP_TEXT =
  "Hola, vi el sitio de la torre en El Boquerón y me interesa más información.";

export const CONTACT = {
  display: "+503 6103 7567",
  tel: "tel:+50361037567",
  // El mensaje prellenado baja la fricción del primer contacto.
  whatsapp: `https://wa.me/50361037567?text=${encodeURIComponent(WHATSAPP_TEXT)}`,
} as const;

export const COORDINATES = `${SITE.latitude}, ${SITE.longitude}`;

export const COORDINATES_DMS = "13°43′49.9″ N · 89°16′56.2″ O";

export const DIRECTIONS_URL =
  `https://www.google.com/maps/dir/?api=1&destination=${SITE.latitude},${SITE.longitude}`;

export type IncludedIcon =
  | "shelter"
  | "power"
  | "vehicle"
  | "parking"
  | "security"
  | "operator";

export const INCLUDED: ReadonlyArray<{ icon: IncludedIcon; label: string }> = [
  { icon: "shelter", label: "Caseta" },
  { icon: "power", label: "Energía 220 V" },
  { icon: "vehicle", label: "Acceso vehicular" },
  { icon: "parking", label: "Parqueo" },
  { icon: "security", label: "Vigilancia" },
  { icon: "operator", label: "Operador permanente" },
];

export const LANDMARKS: readonly string[] = [
  "A la par de SBA y RadioCom",
  "Entrada principal al cráter de El Boquerón",
];
